module.exports = __webpack_public_path__ + "img/check2-circle.c144fa58.svg";